/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeePayDetails } from './EmployeePayDetails';
import {
    EmployeePayDetailsFromJSON,
    EmployeePayDetailsFromJSONTyped,
    EmployeePayDetailsToJSON,
    EmployeePayDetailsToJSONTyped,
} from './EmployeePayDetails';

/**
 * 
 * @export
 * @interface ListEmployeePayDetailResponse
 */
export interface ListEmployeePayDetailResponse {
    /**
     * 
     * @type {Array<EmployeePayDetails>}
     * @memberof ListEmployeePayDetailResponse
     */
    data: Array<EmployeePayDetails>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeePayDetailResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeePayDetailResponse interface.
 */
export function instanceOfListEmployeePayDetailResponse(value: object): value is ListEmployeePayDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeePayDetailResponseFromJSON(json: any): ListEmployeePayDetailResponse {
    return ListEmployeePayDetailResponseFromJSONTyped(json, false);
}

export function ListEmployeePayDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeePayDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeePayDetailsFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeePayDetailResponseToJSON(json: any): ListEmployeePayDetailResponse {
      return ListEmployeePayDetailResponseToJSONTyped(json, false);
  }

  export function ListEmployeePayDetailResponseToJSONTyped(value?: ListEmployeePayDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeePayDetailsToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

